import PropTypes from 'prop-types';
import { Box, Paper, Typography } from '@mui/material';
import { t } from './translations';
export default function ProfileSection({ title, description, children }) {
    return (
        <Paper
            component="section"
            variant="outlined"
            sx={{
                p: {
                    xs: 2.5,
                    md: 3
                },
                borderColor: 'divider',
                borderRadius: 3
            }}
        >
            <Typography
                component="h2"
                variant="h3"
                sx={{
                    color: 'primary.main',
                    mb: 0.75
                }}
            >
                {t(title)}
            </Typography>
            {t(description) && (
                <Typography
                    color="text.secondary"
                    variant="body2"
                    sx={{
                        mb: 2.5
                    }}
                >
                    {t(description)}
                </Typography>
            )}
            <Box
                sx={{
                    mt: description ? 0 : 2.5
                }}
            >
                {children}
            </Box>
        </Paper>
    );
}
ProfileSection.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    children: PropTypes.node.isRequired
};
